<script setup lang="ts">
import FormComodidade from '../components/form-comodidade.vue'
import { useComodidadeStore } from '../store/useComodidadeStore'

definePage({
  meta: {
    navActiveLink: 'admin-comodidade',
    action: 'edit',
    subject: 'comodidade',
  },
})

const store = useComodidadeStore()
const router = useRouter()

const {
  fetchItem,
} = store

fetchItem(router.currentRoute.value.params.id)
</script>

<template>
  <FormComodidade is-editing />
</template>
